export const APP_LIGHT_MODE = 'light';
export const APP_DARK_MODE = 'dark';
export const SPACING_BASE_UNIT = 8;
export const LAYOUT_PADDING = 8;
export const DRAWER_WIDTH = 382;
export const SETTINGS_SUBHEADER_DESKTOP_MARGIN_BOTTOM = 2;
export const SETTINGS_SUBHEADER_TABLET_MOBILE_MARGIN_BOTTOM = 1;
export const SETTINGS_ITEM_MAX_WIDTH = '476px';

// Resource Library Card dimensions
export const RESOURCE_LIBRARY_CARD_WIDTH_MOBILE = 155;
export const RESOURCE_LIBRARY_CARD_WIDTH_TABLET = 170;
export const RESOURCE_LIBRARY_CARD_IMAGE_HEIGHT_MOBILE = 115;
export const RESOURCE_LIBRARY_CARD_IMAGE_HEIGHT_TABLET = 127;
export const RESOURCE_LIBRARY_CARD_CONTENT_HEIGHT_MOBILE = 75;
export const RESOURCE_LIBRARY_CARD_CONTENT_HEIGHT_TABLET = 83;

/** For Infinite scroll how far before the list end (px) the next page starts loading on infinite scroll. */
export const NEXT_PAGE_LOAD_PADDING = '200px';

/**
 * Most resource cards per row at each breakpoint. Enforced by RESOURCE_SECTION_MAX_WIDTH: the
 * section is capped at exactly this many design-width cards, and ResourceCardGrid's auto-fill
 * tracks can't fit more than that.
 */
export const RESOURCE_CARDS_PER_ROW = {
  xs: 2,
  sm: 4,
  md: 5,
};

/**
 * Narrowest a fluid resource card may get - ResourceCardGrid's minimum track width. Below this,
 * the grid drops a card per row (5→4→3 on desktop/tablet, 2→1 on mobile) instead of shrinking further.
 */
export const RESOURCE_CARD_MIN_WIDTH = 140;

/**
 * Horizontal padding for resource section containers at each breakpoint
 */
export const RESOURCE_SECTION_PADDING = {
  xs: 2,
  sm: 3,
  md: 4,
};

// Gap between cards in ResourceCardGrid.
export const RESOURCE_SECTION_CARD_GUTTER = SPACING_BASE_UNIT * 2;

// Cards are fluid but capped at their design width, so the section is capped at exactly the space
// the target cards-per-row + gutters + padding need - at that width each column equals the design
// card width; below it, columns (and cards) shrink.
const computeSectionMaxWidth = (cardsPerRow: number, cardWidth: number, paddingFactor: number) => {
  const cardsRowWidth = cardsPerRow * cardWidth + (cardsPerRow - 1) * RESOURCE_SECTION_CARD_GUTTER;
  const horizontalPadding = paddingFactor * SPACING_BASE_UNIT * 2;
  return `${cardsRowWidth + horizontalPadding}px`;
};

/**
 * Maximum width constraints for resource section containers.
 * - Mobile (xs): fits 2 cards (155px) per row
 * - Tablet (sm): fits 4 cards (170px) per row
 * - Desktop (md/lg): fits 5 cards (170px) per row
 */
export const RESOURCE_SECTION_MAX_WIDTH = {
  xs: computeSectionMaxWidth(
    RESOURCE_CARDS_PER_ROW.xs,
    RESOURCE_LIBRARY_CARD_WIDTH_MOBILE,
    RESOURCE_SECTION_PADDING.xs,
  ),
  sm: computeSectionMaxWidth(
    RESOURCE_CARDS_PER_ROW.sm,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.sm,
  ),
  md: computeSectionMaxWidth(
    RESOURCE_CARDS_PER_ROW.md,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.md,
  ),
  lg: computeSectionMaxWidth(
    RESOURCE_CARDS_PER_ROW.md,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.md,
  ),
};
